const toRad = (x) => {
  return (x * Math.PI) / 180;
};

export default toRad;
